export const appRoutes = {
  home: '/',
  questPlanner: '/quest-planner/:authenticatorId',
  unlock: '/unlock/:authenticatorId',
  passwordGenerator: '/password-generator',
  contact: '/contact',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  marketing: import.meta.env.VITE_MARKETING_URL,
  notFound: '/*'
} as const
